import { render, staticRenderFns } from "./kraHung.vue?vue&type=template&id=99d02c82&scoped=true"
import script from "./kraHung.vue?vue&type=script&lang=js"
export * from "./kraHung.vue?vue&type=script&lang=js"
import style0 from "./kraHung.vue?vue&type=style&index=0&id=99d02c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d02c82",
  null
  
)

export default component.exports